import {
	createTheme,
	Grid,
	InputAdornment,
	TextField,
	ThemeProvider,
	Typography,
} from "@mui/material";
import { getCcyDataByCcy } from "../utils/CurrencyHelper";
import { Currency } from "../models/Currency";
import { useNumberInput } from "../hooks/UseNumberInput";
import { useEffect } from "react";
import { GREY_3141, GREY_7979 } from "../styles/Colors";

interface DisplayProps {
	ccy: string;
	value: string;
	onChangeValue: any;
	setFocusedSide: any;
	side: string;
}

function AmountTextField(props: DisplayProps) {
	const { ccy, value, onChangeValue, setFocusedSide, side } = props;
	const ccyConfigObj: Currency = getCcyDataByCcy(ccy);

	const theme = createTheme();

	theme.typography.body1 = {
		fontSize: "22px",
		fontFamily: "Avenir",
		fontWeight: "Bold",
		[theme.breakpoints.down("sm")]: {
			fontSize: "18px",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: "18px",
		},
	};

	const { onChange, onBlur, onFocus } = useNumberInput(
		ccy,
		onChangeValue,
		value
	);

	const onFocusField = () => {
		setFocusedSide(side);
		onFocus();
	};

	const onBlurField = () => {
		onBlur();
	};

	useEffect(() => {
		onFocus();
		onBlur();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ccy]);

	const inputProps = value !== '' 
		? {
			startAdornment: (
				<InputAdornment position="start">
					<Typography
						textAlign="right"
						variant="body1"
						color={GREY_3141}
						paddingLeft="0.4rem"
					>
						{ccyConfigObj.symbol || ""}
					</Typography>
				</InputAdornment>
			),
			type: "numeric",
			disableUnderline: true, 
			} 
		: {
			type: "numeric",
			disableUnderline: true, 
		};
		
	return (
		<Grid padding={1}>
			<ThemeProvider theme={theme}>
				<TextField
					value={value}
					placeholder="Enter Amount"
					variant="standard"
					onChange={(e) => onChange(e.target.value)}
					fullWidth
					onBlur={onBlurField}
					sx={{
						"& .MuiInputBase-input": {
							overflow: "hidden",
							textOverflow: "ellipsis",
							color: GREY_3141,
							"&::placeholder": {
								fontSize: "16px",
								fontFamily: "Avenir",
								[theme.breakpoints.down("sm")]: {
									fontSize: "13px",
								},
								fontWeight: '500',
								color: GREY_7979,
								opacity: 1,
								paddingLeft: '5px',
							},
						},
					}}
					onFocus={onFocusField}
					InputProps={inputProps}
				/>
			</ThemeProvider>
		</Grid>
	);
}

export default AmountTextField;
